export { editCustomerDeliveryAddress } from './api'
export {
  AutoOpenModalAddDeliveryAddressManager,
  default as ModalAddDeliveryAddress,
  ModalRemoveDeliveryAddress
} from './components/ModalAddDeliveryAddress'
export {
  default as ModalAddInvoiceAddress,
  ModalRemoveInvoiceAddress
} from './components/ModalAddInvoiceAddress'
export { useCustomerAddresses } from './hooks/useCustomerAddresses'
export { AddressServiceSingleton, isLatitudeAndLongitudeError } from './mappers'
export {
  autoCompletePostalCode,
  validatePostalCodeField,
  validatePostalCodeValues
} from './postalCodes'
export { queryFetchDeliveryAddresses } from './queries/useQueryCustomerDeliveryAddresses'
export type {
  CustomerAddress,
  CustomerInvoiceAddress
} from './types'
export { CustomerAddressType, InvoiceType } from './types'
export {
  findDefaultInvoiceAddress,
  getAddressCoordinates,
  IS_PERSONAL_INVOICE_ENABLED,
  isAddressExistInAddresses,
  isCompanyInvoiceAddress} from './utils'
